module.exports = __webpack_public_path__ + "media/images/list_sort-4b47c2cb.svg";